/** 默认 API 根地址（.env 未生效时的兜底，避免请求落到 localhost:8080 导致 404） */
export const DEFAULT_API_BASE_URL = 'https://lc.k2yun.com'
